import React from "react";
import Stepper from "./Stepper";
import ReCaptchaProviderWrapper from "../Home/Container/ReCaptchaProviderWrapper";
function Demo() {
  return (
    <div style={{ paddingBottom: 45 }}>
      <ReCaptchaProviderWrapper>
        <Stepper />
      </ReCaptchaProviderWrapper>
    </div>
  );
}

export default Demo;
